import type { IconType } from 'react-icons';
import { MdArrowOutward, MdOutlineDescription, MdOutlineFileDownload } from 'react-icons/md';
import type { BackgroundJobActionType } from './backgroundJobKinds';

/** Значки действий итога — одни в превью у колокольчика, детали уведомления и окне задачи. */
export const JOB_ACTION_ICONS: Readonly<Record<BackgroundJobActionType, IconType>> = {
    download: MdOutlineFileDownload,
    openDocument: MdOutlineDescription,
    openLink: MdArrowOutward,
};
